import { render, staticRenderFns } from "./View-qi.vue?vue&type=template&id=10dd6603&"
import script from "./View-qi.vue?vue&type=script&lang=js&"
export * from "./View-qi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports